import React from 'react'
import { Card,CardActions,CardContent,CardMedia,Container,Typography,Box, Button, Link as LinkMui, Badge, styled } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { fontSize } from '@material-ui/system';
import ItemCount2 from '../ItemCount/ItemCount2'
// import {config} from "../../config/config";
import {config} from "../../config/config";
import { Edit as EditIcon } from '@material-ui/icons';
import ApiQuery from "../utils/apiQuery/apiQuery"
import { CartContext } from '../CartContext/CartContext';
let apiQuery = new ApiQuery();

function capitalizeFirstLetter(string) {
  let cadena = string.toLowerCase()
  return cadena.charAt(0).toUpperCase() + cadena.slice(1);
}

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: 30,
    top: 1,
    // border: `2px solid ${theme.palette.background.paper}`,
    // padding: '10 4px',
  },
}));

const Item = ({product, name, description, img, stock, model,sku, price, categoria}) => {
  const cartContext = React.useContext(CartContext);
  const canViewPrice = cartContext?.canViewPrice;
  const [isAdmin, setIsAdmin] = React.useState(false);
  const [iva, setIva] = React.useState(0);
  const [isExpanded, setIsExpanded] = React.useState(false);
  const maxLength = 100;
  const [imgSrc, setImgSrc] = React.useState(`${config.SERVER}/images/${img || "sin_imagen.jpg"}`);

  const handleImageError = () => {
    setImgSrc(`${config.SERVER}/images/sin_imagen.jpg`);
  };

  React.useEffect(() => {
    setImgSrc(`${config.SERVER}/images/${img || "sin_imagen.jpg"}`);
  }, [img]);

  React.useEffect(() => {
    let cancel = false;
    apiQuery.get(`/permisos/nivel`)
    .then((respuesta)=>{
      if (cancel) return;
      setIsAdmin(respuesta)
    })
    return () => { cancel = true; }
  }, [])

  React.useEffect(() => {
    setIva(parseFloat(typeof product.iva === "string" ? product.iva.replace(/,/g, '.').replace(/%/g, '') : product.iva))
  }, [])
  
  function ccyFormat(num) {
    let numFloat = parseFloat(num)
    return `${numFloat.toFixed(2)}`;
  }

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };
  
	return (
    <>
      <StyledBadge 
        badgeContent={
          product.oferta == "si" && product.novedades != "si"
            ? "OFERTA"
            : product.novedades == "si"
            ? "NOVEDADES"
            : 0
        }
        color={
          product.oferta == "si" && product.novedades != "si"
            ? "error"
            : product.novedades == "si"
            ? "success"
            : "info"
        }
      >
        <Card
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "center",
            paddingY: "20px",
          }}
        >
          <Container
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Link to={`/detail/${sku}`}>
              {/* <CardMedia component="img" image={`${config.SERVER}/images/${img ? img : "sin_imagen.jpg"}`} alt="sin imagen" /> */}
              <CardMedia 
                component="img" 
                image={imgSrc} 
                onError={handleImageError}
                sx={{height:{xs:"150px",sm:"200px"}, width:"100%", objectFit:"cover"}} 
                alt="sin imagen" 
              />
            </Link>
          </Container>
          <CardContent sx={{ margin: 0,p:{xs:1,md:2} }}>
            <Typography gutterBottom sx={{fontSize:{xs:"x-small",sm:"small",md:"medium"}, minHeight:35}}  variant="body" component="div">
              {name.length > maxLength ? (
                <>
                  {isExpanded ? capitalizeFirstLetter(name) : `${capitalizeFirstLetter(name).substring(0, maxLength)}...`}
                  <Button variant="text" size="small" onClick={toggleExpanded} sx={{fontSize:"x-small"}}>
                    {isExpanded ? 'Leer menos' : 'Leer más'}
                  </Button>
                </>
              ) : (
                capitalizeFirstLetter(name)
              )}
            </Typography>
            <Typography gutterBottom sx={{fontSize:{xs:"x-small",sm:"small",md:"medium"}}}  variant="body2" color="text.secondary" component="div">
              {capitalizeFirstLetter(model)}
            </Typography>
            <Typography gutterBottom sx={{fontSize:{xs:"x-small",sm:"small",md:"medium"}}}  variant="body2" color="text.secondary" component="div">
              {categoria && `${categoria}`}
            </Typography>
            <Link to={`/detail/${sku}`}>
              <Typography sx={{fontSize:{xs:"x-small",sm:"small"}}}  variant="caption" color="text.secondary">
                Código: {description}
              </Typography>
              <Typography sx={{ fontWeight: "bold", textDecoration: "none", color: canViewPrice ? "text.primary" : "primary.main", fontSize: canViewPrice ? {xs:"small",sm:"medium"} : {xs:"x-small",sm:"small"} }} variant="h6">
                {canViewPrice ? (price ? `$ ${ccyFormat(price)}` : "NO DISPONIBLE") : "Inicie sesión para ver precio"}
              </Typography>
            </Link>
            {isAdmin ? <>
                <LinkMui href={`${config.ADMINISTRADOR}/producto/${sku}`} target="_blank" style={{ textDecoration:"none", color:"inherit"}}>
                  <Button startIcon={<EditIcon />} size="small" variant="contained" color="primary"  sx={{ fontSize: 12, mt:1}}>Editar</Button>
                </LinkMui>
              </> : <></>
            }
          </CardContent>
          <CardActions
            sx={{
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            {/* <Typography sx={{fontSize:{xs:"x-small",sm:"small"}}} variant="caption">(Stock: {stock})</Typography> */}
            <Box>
              {/* <Link to={`/detail/${sku}`} style={{ textDecoration:"none", color:"inherit"}}>
                <Button
                  size="medium"
                  variant="contained"
                  color="success"
                  sx={{ fontSize:{xs:"xsmall",sm:"small",md:"medium"}, width: "100%" }}
                >
                <Typography sx={{fontSize:{xs:"xsmall",sm:"small"}}} variant="caption">Detalles</Typography>

                </Button>
              </Link> */}
              <ItemCount2
              product={product}
              initial={1}
              stock={stock}
              price={price}
            />
            </Box>
          </CardActions>
        </Card>
      </StyledBadge>
    </>
  );
}

export default Item
